export default "__VITE_ASSET__C$n62La___"